import React, { useEffect, useState } from 'react';
import { Activity } from 'lucide-react';
import { api } from '../../lib/api';

// ActivityFeed — Sprint G item 9.4 shared component for global, per-account,
// and per-user activity views. Caller passes the API path; we render rows.

function fmtDate(s) { return s ? String(s).slice(0, 19).replace('T', ' ') : '—'; }

function actionLabel(t) {
  return String(t || '').replace(/\./g, ' › ').replace(/_/g, ' ');
}

export default function ActivityFeed({ apiPath }) {
  const [data, setData] = useState({ activity: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api.get(apiPath)
      .then((d) => { if (alive) setData(d || { activity: [] }); })
      .catch((err) => { if (alive) setError(err?.data?.error || err?.message || ''); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [apiPath]);

  if (loading) return <div className="text-[12px] text-gray-500">Loading…</div>;
  if (error) return <div className="text-[12px] text-red-300/90">{error}</div>;
  const rows = data.activity || [];

  return (
    <div data-testid="activity-feed" className="rounded-2xl border border-white/[0.06] bg-white/[0.02] overflow-hidden">
      <div className="flex items-center gap-2 px-4 py-2.5 border-b border-white/[0.04] text-[10px] uppercase tracking-wider text-gray-500">
        <Activity className="w-3 h-3" />
        Activity
      </div>
      {rows.length === 0 ? (
        <div className="px-4 py-6 text-[12px] text-gray-500">No activity recorded yet.</div>
      ) : (
        <ul className="divide-y divide-white/[0.04]">
          {rows.map((r) => (
            <li key={r.id} data-testid={`activity-row-${r.id}`} className="px-4 py-2.5 grid grid-cols-12 gap-2 items-baseline text-[13px]">
              <div className="col-span-4 lg:col-span-3 text-[11px] text-gray-500">{fmtDate(r.createdAt)}</div>
              <div className="hidden lg:block lg:col-span-2 text-[11px] text-gray-400 uppercase tracking-wider">{r.userRole}</div>
              <div className="col-span-5 lg:col-span-3 text-white truncate">{r.userName || r.userEmail || '—'}</div>
              <div className="col-span-3 text-gray-300">{actionLabel(r.actionType)}</div>
              <div className="hidden lg:block lg:col-span-1 text-[11px] text-gray-500 truncate">{r.entityType ? `${r.entityType.slice(0, 4)}` : ''}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
